import React from 'react';
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from '@react-navigation/native-stack';
import {useTheme} from 'contexts/ThemeContext';
import {Flows, ScreenName, Screens} from './Screens';
import HeaderBackButton from 'components/atoms/headerBackButton';
import strings from '../translations';
import styleSheet from './styles';
import {RouteProp} from '@react-navigation/native';
import {Platform} from 'react-native';

const Stack = createNativeStackNavigator();

interface ConferenceParams {
  name: string;
  id: string;
}

export interface HomeScreenProps {
  navigation: NativeStackNavigationProp<{
    [ScreenName.createClass]: undefined;
    [ScreenName.conference]: ConferenceParams;
    [Flows.profileFlow]: undefined;
  }>;
}

export interface ConferenceScreenProps {
  navigation: NativeStackNavigationProp<{
    [ScreenName.chat]: undefined;
  }>;
  route: any;
  // RouteProp<{
  //   [ScreenName.conference]: ConferenceParams;
  // }>;
}

export interface ChatScreenProps {
  navigation: NativeStackNavigationProp<{}>;
}

const HomeFlow = () => {
  const theme = useTheme();
  const styles = styleSheet(useTheme());

  return (
    <Stack.Navigator
      screenOptions={({navigation, route}) => ({
        headerLeft: () => <HeaderBackButton onPress={() => navigation.pop()} />,
        headerStyle: styles.headerStyle,
        headerTitleStyle: styles.headerTitleStyle,
        headerTitleAlign: 'center',
        headerShadowVisible: false,
      })}>
      <Stack.Screen
        name={Screens.HomeScreen.name}
        component={Screens.HomeScreen.screen}
        options={{headerShown: false}}
      />
      <Stack.Screen
        name={Screens.CreateClassScreen.name}
        component={Screens.CreateClassScreen.screen}
        options={{
          title: strings.createClassScreen.createClass,
          headerShown: Platform.OS !== 'web',
        }}
      />
      <Stack.Screen
        name={Screens.ConferenceScreen.name}
        component={Screens.ConferenceScreen.screen}
        options={{headerShown: false}}
      />
      <Stack.Screen
        name={Screens.ChatScreen.name}
        component={Screens.ChatScreen.screen}
        options={{
          title: strings.chat.title,
        }}
      />
    </Stack.Navigator>
  );
};

export default HomeFlow;
